export enum TicketTerminationStatusASM {

  IN_PROGRESS = "IN_PROGRESS",    // SBM: PROPOSED, APPROVED, TRANSFERRED
  ABORTED = "ABORTED",        // SBM: DECLINED, CANCELLED,
  COMPLETED = "COMPLETED"       // SBM: COMPLETED -> TicketStatus.Terminated

}
